import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isLoggedIn, setIsLoggedIn] = useState(
    JSON.parse(localStorage.getItem("isLoggedIn")) || false
  );
  const [isSuperuser, setIsSuperuser] = useState(
    JSON.parse(localStorage.getItem("isSuperuser")) || false
  );
  const [username, setUsername] = useState(
    localStorage.getItem("username") || ""
  );

  useEffect(() => {
    localStorage.setItem("isLoggedIn", isLoggedIn);
  }, [isLoggedIn]);

  useEffect(() => {
    localStorage.setItem("isSuperuser", isSuperuser);
  }, [isSuperuser]);

  useEffect(() => {
    localStorage.setItem("username", username);
  }, [username]);

  const clearAuth = useCallback(() => {
    setIsLoggedIn(false);
    setIsSuperuser(false);
    setUsername("");
  }, []);

  // APIが401（セッション切れ・未ログイン）を返したらログイン画面へ戻す。
  // 各画面のfetchを個別に直さずに済むよう、window.fetch を1か所でラップする
  useEffect(() => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const originalFetch = window.fetch;
    window.fetch = async (input, init) => {
      const response = await originalFetch(input, init);
      const url = typeof input === "string" ? input : input?.url || "";
      if (
        response.status === 401 &&
        url.startsWith(`${apiUrl}/api/`) &&
        !url.startsWith(`${apiUrl}/api/login/`)
      ) {
        clearAuth();
      }
      return response;
    };
    return () => {
      window.fetch = originalFetch;
    };
  }, [clearAuth]);

  // 起動時にセッションが有効か確認する（localStorageの状態だけでは判定しない）
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("isLoggedIn"))) return;
    const apiUrl = process.env.REACT_APP_API_URL;
    fetch(`${apiUrl}/api/me/`, { credentials: "include" }).catch((error) => {
      console.error("セッション確認に失敗しました:", error);
    });
  }, []);

  const logout = async () => {
    if (window.confirm("ログアウトしてよろしいですか？")) {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        await fetch(`${apiUrl}/api/logout/`, {
          method: "POST",
          credentials: "include",
        });
      } catch (error) {
        console.error("ログアウトに失敗しました:", error);
      }
      clearAuth();
    }
  };

  const value = {
    isLoggedIn,
    setIsLoggedIn,
    isSuperuser,
    setIsSuperuser,
    username,
    setUsername,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
